import DeleteConfirmModal from "./DeleteConfirmModal";

export default DeleteConfirmModal;
